import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/about-me-one.jpg'
import _imports_1 from '@/assets/images/about-me-two.jpg'
import _imports_2 from '@/assets/images/html.svg'
import _imports_3 from '@/assets/images/typescript.svg'
import _imports_4 from '@/assets/images/c-sharp.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("figure", { class: "about-banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    loading: "lazy",
    alt: "Ethan's Photo",
    class: "img-cover"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    loading: "lazy",
    alt: "Ethan's Photo",
    class: "abs-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "abs-icon abs-icon-1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "",
      style: {"width":"48px","height":"48px"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "abs-icon abs-icon-2" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "",
      style: {"width":"48px","height":"48px"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "abs-icon abs-icon-3" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "",
      style: {"width":"48px","height":"48px"}
    })
  ])
], -1)
const _hoisted_2 = { class: "about-content" }
const _hoisted_3 = {
  href: "#my-works",
  class: "btn btn-primary blue"
}

import CSection from "@/components/section/CSection.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CAboutMe',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CSection, {
    class: "about",
    id: "about-me"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CSectionSubtitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('about-me-i-am-profession')), 1)
          ]),
          _: 1
        }),
        _createVNode(CSectionTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('about-me-quote')), 1)
          ]),
          _: 1
        }),
        _createVNode(CSectionText, {
          innerHTML: _ctx.$t('about-me-description')
        }, null, 8, ["innerHTML"]),
        _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('about-me-view-portfolio')), 1)
      ])
    ]),
    _: 1
  }))
}
}

})